import { useContext } from 'react';
import { LocationContext } from '../contextProviders';
import { Location } from '../types';

export const useLocation: () => Location | undefined = () => {
    return useContext(LocationContext);
};
